import type { FC } from 'react';
import type { TooltipedIconProps } from '@components/TooltipedIcon';
import { TooltipedIcon } from '@components/TooltipedIcon';
import { mdiClose } from '@mdi/js';

export const CloseIconButton: FC<Omit<TooltipedIconProps, 'path'>> & { dataTestId?: string } = (props) => {
  const { dataTestId } = props;
  return (
    <TooltipedIcon
      aria-label="Clear"
      data-testid={dataTestId ?? 'Clear-dropdown'}
      placement="top"
      path={mdiClose}
      className="text-info-800 hover:text-error-500 h-fit cursor-pointer"
      size={0.65}
      content="Clear"
      {...props}
    />
  );
};
